/**
 * Layouts barrel export
 * @module layouts
 */

export { PublicLayout } from './PublicLayout';
export { DashboardLayout } from './DashboardLayout';
export { Header } from './Header';
export { Footer } from './Footer';
